import exchangeTransaction from '@/api/exchange-transaction'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  customers: [],
  employees: [],
  currencies: [],
  date_from: '',
  date_to: ''
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_CUSTOMERS(state, data) {
    state.customers = data
  },
  SET_EMPLOYEES(state, data) {
    state.employees = data
  },
  SET_CURRENCIES(state, data) {
    state.currencies = data
  },
  SET_DATE_FROM(state, data) {
    state.date_from = data
  },
  SET_DATE_TO(state, data) {
    state.date_to = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to
      },
      attrubutes
    )
    return exchangeTransaction.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  getRateAmount(context, params) {
    return exchangeTransaction.getRateAmount({ params })
  },

  store(context, data) {
    return exchangeTransaction.store(data)
  },

  update(context, data) {
    return exchangeTransaction.update(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await exchangeTransaction.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async dataBeforeCreate(context) {
    if (!context.state.customers.length > 0) {
      let response = await exchangeTransaction.customer()
      context.commit('SET_CUSTOMERS', response.data)
    }
    if (!context.state.employees.length > 0) {
      let response = await exchangeTransaction.employee()
      context.commit('SET_EMPLOYEES', response.data)
    }
    if (!context.state.currencies.length > 0) {
      let response = await exchangeTransaction.currency()
      context.commit('SET_CURRENCIES', response.data)
    }
  }
}
